import { Client, Account, Databases, Functions } from "appwrite";

export const API_ENDPOINT = "https://api.oakmate.app/v1";
export const PROJECT_ID = process.env.REACT_APP_PROJECT_ID;

if (!PROJECT_ID) {
    throw new Error(
        "REACT_APP_PROJECT_ID is not set in the environment variables."
    );
}

const client = new Client().setEndpoint(API_ENDPOINT).setProject(PROJECT_ID);

export const account = new Account(client);
export const databases = new Databases(client);
export const functions = new Functions(client);

export default client;
